import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import {
    Modal,
    ModalBody,
    Row,
    Col 
  } from 'reactstrap';
import styled from "styled-components";
import classNames from 'classnames';
import ReactLoading from 'react-loading';

import IconClose from '../../images/close-button-black.png';
import { Button } from '../Forms';

const ModalAlert = props => {
  return (
    <Modal 
      toggle={props.onToggle}
      modalClassName="kick-notification-wrapper"
      isOpen={props.isOpen}
      className="kick-modal modal-notification"
    >
      <CloseWrapper onClick={props.onToggle}>
        <KickImage src={IconClose} alt="close-button-black.png"/>
      </CloseWrapper>

      <ModalBody>
        <Col>
          <p style={{textAlign: 'center'}}> {props.contentText} </p>
          {
            props.showButton?
            <DecisionWrapper>
              <Button 
                className={classNames("btn-white flat", {"is-disabled": props.disabled})} 
                onClick={props.disabled? null : props.onSubmit}
                disabled={props.disabled || props.isLoading}
              >
                {
                  props.isLoading? 
                  <LoadingWrapper>
                    <ReactLoading
                      type={'spin'}
                      height={20}
                      width={20}
                      color={"#000"}
                    />
                  </LoadingWrapper>
                  :
                  "Yes"
                }
              </Button>
              <NoWrapper onClick={props.onToggle}>
                <span>No, cancel</span>
              </NoWrapper>
            </DecisionWrapper> : null
          }
        </Col>
      </ModalBody>
    </Modal>
  )
}

const CloseWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  img{
    width: 15px;
    height: 15px;
    cursor: pointer;
  }
`;

const DecisionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    .btn-white{
      width: 50% !important;
    }
    .btn.disabled {
      background-color: unset;
    }
`;

const NoWrapper = styled.div`
  margin-top: .5rem;
  span{
    color: #FF1200;
    text-decoration: underline;
    text-align: center;
    cursor: pointer;
  }
`;

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
`

export default ModalAlert;

